import type { IconData } from '@stacksjs/iconify-core'

export const capsule: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 9V5a3 3 0 1 0-6 0v4zm0 2H2v4a3 3 0 0 0 6 0zM5 0a5 5 0 0 1 5 5v10a5 5 0 0 1-10 0V5a5 5 0 0 1 5-5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default capsule
